import { InlineBadgeEditor, type BadgeColor } from "@rothoblaas/design-system";
import { FC } from "react";
import useI18n from "../../hooks/useTranslations";
import { getVisibilityScopeLabels, VisibilityScopes, VisibilityScopeValue } from "./VisibilityScope";

const colorByScope: Record<VisibilityScopeValue, BadgeColor> = {
  public: "success",
  internal: "info",
  hidden: "warning",
};

export type VisibilityProps = {
  value?: VisibilityScopeValue;
  onChange: (value: VisibilityScopeValue) => void;
};

const Visibility: FC<VisibilityProps> = ({ value, onChange }) => {
  const i18n = useI18n();
  const labels = getVisibilityScopeLabels(i18n);
  const options = VisibilityScopes.map((scope) => ({
    value: scope,
    label: labels[scope],
    color: colorByScope[scope],
  }));

  return <InlineBadgeEditor<VisibilityScopeValue> value={value} options={options} onChange={onChange} />;
};

export default Visibility;
